import { useTranslation } from "react-i18next";

const InputPasswordComp = (props) => {

   const {formik,myFunction,setPassword,password,setIsSocial} = props;
   const { t } = useTranslation();

    return (<>

      <div className="input-text ">
      <label
        htmlFor="password"
        className="input__label"
      >
        {t("Password")}
      </label>
      <div className="position-relative">
      <input
        id="passInput"
        className="input__field"
        name="password"
        type="password"
        placeholder="Enter your password"
        // onChange={formik.handleChange}
        // value={formik.values.password}
        onChange={(evt)=>{setPassword(evt.target.value)}}
        value={password}
        required
        autoComplete="off"
      />
      <div
        className="show-pass"
        onClick={() => {
          myFunction();
        }}
      >
        <img
          id="eyeImg"
          src="/images/private.png"
          alt="view"
        />
      </div>
      </div>
    </div>
    
    </>)


}
export default InputPasswordComp